// extracted by mini-css-extract-plugin
export var auto = "_3y-1";
export var spinner = "_3y-0";